import React from 'react';
import { Gift, MessageSquare, AlertTriangle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const bonusItems = [{
  icon: MessageSquare,
  text: '50 mensajes listos para copiar y pegar'
}, {
  icon: AlertTriangle,
  text: 'Los 3 errores que hacen que te ignoren (y cómo evitarlos)'
}];
export function BonusSection() {
  return <section className="py-14 px-6 relative overflow-hidden bg-[#161616]" data-id="element-24">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-25" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-26">
        <FadeIn data-id="element-27">
          <div className="text-center mb-8" data-id="element-28">
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-3 text-amber-400" data-id="element-29">
              BONOS EXCLUSIVOS
            </h2>
            <p className="text-brand-lightGray text-lg max-w-2xl mx-auto" data-id="element-30">
              Llévate esto completamente{' '}
              <span className="text-amber-400 font-bold" data-id="element-31">GRATIS</span> con tu
              compra hoy.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 items-center mt-8" data-id="element-32">
          <FadeIn direction="left" data-id="element-33">
            <div className="relative flex justify-center" data-id="element-34">
              <div className="absolute inset-0 bg-rose-500/10 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-35" />
              <img src="https://cdn.magicpatterns.com/uploads/wpFEkxicUk1UhyRdBMoevM/ChatGPT_Image_29_mar_2026,_06_43_55_p.m..png" alt="Bonos Exclusivos" className="relative z-10 w-full max-w-sm rounded-2xl shadow-2xl shadow-rose-500/15 border border-white/10" data-id="element-36" />
            </div>
          </FadeIn>

          <FadeIn direction="right" data-id="element-37">
            <div className="bg-[#0a0a0a] border border-amber-500/20 rounded-3xl p-6 md:p-8 relative overflow-hidden" data-id="element-38">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-amber-400" data-id="element-39" />

              <div className="flex items-center gap-3 mb-6" data-id="element-40">
                <Gift className="w-8 h-8 text-amber-400" data-id="element-41" />
                <h3 className="font-serif text-2xl font-bold text-brand-cream" data-id="element-42">
                  Incluido hoy:
                </h3>
              </div>

              <div className="space-y-4" data-id="element-43">
                {bonusItems.map((item, index) => <div key={index} className="flex items-center gap-4 p-4 rounded-xl bg-white/5 border border-white/5" data-id="element-44">
                    <div className="w-10 h-10 rounded-lg bg-amber-500/15 flex items-center justify-center shrink-0" data-id="element-45">
                      <item.icon className="w-5 h-5 text-amber-400" data-id="element-46" />
                    </div>
                    <p className="text-brand-cream font-medium text-base" data-id="element-47">
                      {item.text}
                    </p>
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}